import { render, staticRenderFns } from "./InternshipPaymentPage.vue?vue&type=template&id=fadfa91c&scoped=true"
import script from "./InternshipPaymentPage.vue?vue&type=script&lang=js"
export * from "./InternshipPaymentPage.vue?vue&type=script&lang=js"
import style0 from "./InternshipPaymentPage.vue?vue&type=style&index=0&id=fadfa91c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fadfa91c",
  null
  
)

export default component.exports